<template>
  <div class="logo-container">
    <div class="logo">
        <img src="@/assets/logo.svg" alt="">
        <span>Säkerhets-SM 2021</span>
    </div>
  </div>
  <ClockTimeline />
  <div class="button-container">
    <!-- <button class="button">Registrera dig!</button> -->
    <router-link class="button" tag="button" :to="{ name: 'signin' }">Registrera dig!</router-link>
  </div>
  <div class="content">
    <div>
      <h3>Beskrivning</h3>
      <p>
        Säkerhets-SM är en nationell Capture The Flag tävling för gymnasiet. Tävlingen fokuserar på problemlösning inom områdena programmering, kryptografi, binär exploatering, reverse engineering, webbsäkerhet och forensik. Uppgifterna varierar från nybörjarvänliga till riktigt kluriga, så även om man aldrig deltagit i en CTF förut så kan man delta. Framför allt så lär man sig mycket av att delta.
      </p>
      <p>
        CTF-tävlingar (Capture The Flag) går ut på att man i början av tävlingen får tillgång till en mängd problem och man visar att man har löst en uppgift genom att skicka in uppgiftens "flagga" till plattformen. Flaggor i den här tävlingen är textsträngar på formen "SSM{...}".
      </p>
      <p>
        Årets tävling består av ett kval och en final. Kvalet kommer att utspela sig här mellan den 26 mars klockan 20:00 och den 28 mars klockan 20:00. Tävlingen kommer alltså vara igång i 47h (inte 48h på grund av att det blir sommartid i mitten av tävlingen, bra planerat där). Men det går redan nu att registrera sitt lag!
      </p>
      <h3>Final</h3>
      <p>
        De bästa 10 lagen kvalar till finalen. Finalen kommer att ske digitalt någon gång i maj eller juni.
      </p>
    </div>
    <div>
      <h3>Regler</h3>
      <ul>
        <li>För att ett lag ska vara inom tävlan måste alla dess deltagare gå på gymnasiet eller i grundskolan i Sverige och laget får bestå av högst 3 personer.</li>
        <li>Om något av kraven i föregående regel inte uppnås får man fortfarande delta i tävlingen, men då utom tävlan.</li>
        <li>Det är förbjudet att diskutera problemlösningar och ledtrådar med andra medans tävlingen pågår.</li>
        <li>Det är förbjudet att vara medlem i flera lag samtidigt.</li>
        <li>Det är förbjudet att attackera CTF-platformen. Detta inkluderar brute-forcing av flaggor.</li>
        <li>Respektera problemservrarna. Skapa inte orimligt stor trafik till problemen. Inga uppgifter kräver att man skickar orimligt mycket data för att få flaggan.</li>
        <li>Det är förbjudet att störa andra personers förmåga att lösa problem.</li>
        <li>Det är förbjudet att ha mer än ett konto på CTF-platformen.</li>
        <li>Arrangörernas beslut är slutgiltiga.</li>
      </ul>
      <h3>Discord</h3>
      <p>
        Gå med i Kodsports <a href="https://discord.gg/m6pcEYp">Discordserver</a> för att diskutera tävlingen med andra i #säkerhetssm kanalen! Om du inte har några lagkamrater eller om ditt lag inte är fullt kan man också skicka meddelande i #leta-lag kanalen för att hitta folk att spela med. I discorden finns också alla admins och problemskapare i fall man behöver ta kontakt med dem.
      </p>
    </div>
  </div>
  <h3>Huvudsponsor</h3>
  <div class="mainsponsorcontainer">
    <a href="https://www.sentor.se/">
      <img class="mainsponsor" src="@/assets/sponsors/sentor.png">
    </a>
  </div>
  <h3>Sponsorer</h3>
  <div class="sponsorcontainer">
    <a href="https://www.microaalabs.se/">
      <img class="sponsor" src="@/assets/sponsors/microaa.png">
    </a>
    <a href="https://www.msab.com">
      <img class="sponsor" src="@/assets/sponsors/msab.png">
    </a>
    <a href="https://jobb.orangecyberdefense.com/">
      <img class="sponsor" src="@/assets/sponsors/orange.png">
    </a>
    <a href="https://www.venor.se/">
      <img class="sponsor" src="@/assets/sponsors/venor.png">
    </a>
  </div>
  <p style="text-align: center">Infra sponsored by <a href="https://g.co/cloud">g.co/cloud</a></p>
</template>

<script>
import ClockTimeline from '@/components/ClockTimeline.vue'

export default {
    name: 'Home',
    components: {
        ClockTimeline,
    },
}
</script>

<style lang="scss" scoped>
.logo-container {
  .logo {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    text-align: center;
    max-width: 50rem;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 2rem;
      background-color: rgba(0,44,54, 0.4);
      padding: 0 1rem;
      word-wrap: normal;
    }
  }
}

h1, h3 {
  text-align: center;
}

p {
  padding: 0 10px 0 10px;
}

.button-container {
  margin-top: 2rem;
  text-align: center;
}

.button {
  padding: 0.6rem 1rem;
  font-size: 2rem;
  color: #ffab1c;
}

.content {
  display: grid;
  grid-template-columns: 50% 50%;
  padding-top: 3rem;
}

.mainsponsorcontainer {
  text-align: center;
}

.mainsponsor {
  max-width: 100%;
  max-height: 150px;
  padding-bottom: 1rem;
}

.sponsorcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.sponsor {
  max-width: 90%;
  max-height: 100px;
  margin: 1rem 1rem;
}

@media only screen and (max-width: 990px) {
  .content {
    display: block;
  }
}
</style>
